import { useId } from 'react'

/**
 * The wheel button's own mark and the app's logo ("orbit dots", Gaige's pick 2026-10-22): a
 * pivot dot in the lower right with three dots on a quarter arc around it, a small picture of
 * the wheel it opens. The arc dots are aurora green, ice cyan and ultraviolet (bottom to top,
 * like an aurora), each with a soft glow; the pivot is white. Green, cyan and violet stay
 * distinct for red-green colour blindness (blue and violet would not). 64-unit square, so it
 * scales with the button.
 */
export function WheelMark({ className }: { className?: string }) {
  const glow = `wm-glow-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <defs>
        <filter id={glow} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.4" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter={`url(#${glow})`}>
        <circle cx="17.1" cy="40.7" r="6.2" style={{ fill: 'var(--midnight-mint, var(--mint))' }} />
        <circle cx="24.6" cy="24.6" r="6.2" style={{ fill: 'var(--midnight-sky, var(--sky))' }} />
        <circle cx="40.7" cy="17.1" r="6.2" style={{ fill: 'var(--midnight-lavender, var(--lavender))' }} />
      </g>
      <circle cx="43" cy="43" r="5" fill="rgb(var(--fg-rgb))" />
    </svg>
  )
}
